export const PLAY_RATE_LIST = [0.5, 0.75, 1];
export const AUTO_SPEECH_DEFAULT_RATE = 0.75;
